module.exports = "https://static.wmbcdn.com/uniweb/images/1b90321919b0631ed774a6579574181e.svg";